import React, { useEffect, useState } from "react";

import {
  Alert,
  Select,
  MenuItem,
  Button,
  Snackbar,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  Grid2,
  Typography,
  Link,
  FormGroup,
  FormControlLabel,
  InputAdornment,
  Checkbox,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
} from "@mui/material";

import { styled } from "@mui/material/styles";

import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useDispatch, useSelector } from "react-redux";
import { addressToString } from "../utils/utils";
import constants from "../static/constants.json";
import dayjs, { Dayjs } from "dayjs";
import { JobsAPI } from "../apis/jobsApi";
import { addJobs, editJob } from "../redux/jobSlice";
type JobDialogProps = {
  job: any;
  open: boolean;
  handleClose: () => void;
};

const Input = styled(TextField)(({ theme }) => ({
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    display: "none",
  },
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
}));

const JobDialog = ({ job, open, handleClose }: JobDialogProps) => {
  const [msg, setMsg] = useState<JSX.Element | null>(null);
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);
  const [propertyId, setPropertyId] = useState("");
  const [typeId, setTypeId] = useState("");
  const [showMsg, setShowMsg] = useState(false);
  // const [msg, setMsg] = useState("");
  const [instructions, setInstructions] = useState("");
  const [startTime, setStartTime] = useState(dayjs());
  const [endTime, setEndTime] = useState(dayjs());
  const [errors, setErrors] = useState({} as any);

  const [jobTasks, setJobTasks] = useState([] as any);
  const [fee, setFee] = useState("");
  const [isRecurring, setIsRecurring] = useState(false);
  const [isForever, setIsForever] = useState(false);
  const [frequencyId, setFrequencyId] = useState("");
  const [throughDate, setThroughDate] = useState(null as any);
  const tasks = useSelector((state: any) => state.tasks.list);

  // err is the backend error
  const [err, setErr] = useState("");

  useEffect(() => {
    if (job && !job.id) {
      const selectedProperty = user.properties.find(
        (p: any) => p.id === propertyId
      );

      if (typeId !== "" && selectedProperty && selectedProperty.defaultTasks) {
        const newTasks = tasks.filter((t: any) => {
          return (
            t.jobTypeId === typeId &&
            selectedProperty.defaultTasks.indexOf(t.id) > -1
          );
        });
        setJobTasks(newTasks.map((t: any) => t.id));
      }
    } else if (!job.id) {
      setJobTasks([]);
    }
  }, [propertyId, typeId, tasks, user.properties, job]);

  const addJobTask = (taskId: string, isEnabled: boolean) => {
    let newTasks = [...jobTasks];
    if (isEnabled && newTasks.indexOf(taskId) < 0) {
      newTasks.push(taskId);
    } else if (!isEnabled && newTasks.indexOf(taskId) > -1) {
      newTasks.splice(newTasks.indexOf(taskId), 1);
    }
    setJobTasks(newTasks);
  };

  useEffect(() => {
    if (job.typeId) {
      setStartTime(dayjs(job.startTime));
      setEndTime(dayjs(job.endTime));
      setPropertyId(job.propertyId);
      setTypeId(job.typeId);
      setInstructions(job.instructions);
      setFee(`${job.fee}`);
      console.log("job tasks", job.tasks);
      setJobTasks(job.tasks || []);
    } else {
      setFee("");
      setJobTasks([]);
      setInstructions("");
      setTypeId("");
      setStartTime(dayjs().startOf("hour").add(1, "hour"));
      setEndTime(dayjs().startOf("hour").add(3, "hour"));
      setErrors({});
    }
  }, [job]);

  const saveJob = async () => {
    // TODO validate inputs
    const currErrs = {} as any;

    if (Object.keys(currErrs).length === 0) {
    }

    const body = {
      propertyId,
      typeId,
      startTime,
      endTime,
      instructions,
      tasks: jobTasks,
      fee: parseFloat(fee),
      throughDate,
      frequencyId,
      isForever,
    } as any;

    if (job.id) {
      body.id = job.id;
      try {
        const j = await JobsAPI.updateJob(body);
        dispatch(editJob(j));
        setMsg(
          <>
            Job saved!{" "}
            <Link
              style={{ color: "#ffffff", textDecoration: "underline" }}
              href={`/jobs/${job.id}`}
            >
              View
            </Link>
          </>
        );
        setShowMsg(true);
        handleClose();
      } catch (e) {
        console.log('e is ', e);
        setErr(e as string);
      }
    } else {
      try {
        const j = await JobsAPI.createJob(body);
        dispatch(addJobs(j));
        setMsg(
          <>
            Job posted!{" "}
            <Link
              style={{ color: "#ffffff", textDecoration: "underline" }}
              href={`/jobs/${j[0].id}`}
            >
              View
            </Link>
          </>
        );
        setShowMsg(true);
        handleClose();
      } catch (e) {
        setErr(e as string);
        console.log('e create is ', e);
      }
    }
  };

  const startTimeChange = (newTime: Dayjs) => {
    setStartTime(newTime);
    if (newTime.valueOf() > endTime.valueOf()) {
      setEndTime(dayjs(newTime));
    }
  };

  const closeDialog = () => {
    setErrors({});
    setPropertyId("");
    handleClose();
  };

  return (
    <>
      <Snackbar
        open={showMsg}
        autoHideDuration={6000}
        onClose={() => setShowMsg(false)}
        message={msg}
      >
        <Alert
          onClose={() => setShowMsg(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Dialog
        open={open}
        onClose={closeDialog}
        PaperProps={{
          component: "form",
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            const email = formJson.email;
            console.log(email);
            handleClose();
          },
        }}
      >
        <DialogTitle>
          {job && job.id ? "Edit Job Post" : "New Job Post"}
        </DialogTitle>
        <DialogContent>
          <Grid2 container spacing={3}>
            <Grid2 size={12}>
              <DialogContentText>
                To create a new job posting, fill out this form.
              </DialogContentText>
            </Grid2>
            <Grid2 size={12}>
              <Select
                value={propertyId}
                error={errors.property}
                onChange={(e) => setPropertyId(e.target.value)}
                fullWidth
                // placeholder="Property"
                style={{ width: "100%" }}
                label="Property"
              >
                {user.properties &&
                  user.properties.map((p: any) => (
                    <MenuItem value={p.id}>
                      {addressToString(p.address)}
                    </MenuItem>
                  ))}
              </Select>
            </Grid2>
            <Grid2 size={12}>
              <Select
                value={typeId}
                onChange={(e) => setTypeId(e.target.value)}
                fullWidth
                style={{ width: "100%" }}
                label="Job Type"
              >
                <MenuItem value={constants.jobType.cleaning}>
                  Housekeeping
                </MenuItem>
                <MenuItem value={constants.jobType.landscaping}>
                  Landscaping
                </MenuItem>
                <MenuItem value={constants.jobType.maintenance}>
                  Maintenance
                </MenuItem>
              </Select>
            </Grid2>
            <Grid2 size={6}>
              <DateTimePicker
                sx={{ width: "100%" }}
                label="Start Time"
                value={startTime}
                onChange={(newValue) => startTimeChange(newValue || dayjs())}
              />
            </Grid2>
            <Grid2 size={6} sx={{ border: "1px none green" }}>
              <DateTimePicker
                sx={{ width: "100%" }}
                label="End Time"
                value={endTime}
                onChange={(newValue) => setEndTime(newValue || dayjs())}
              />
            </Grid2>
            {typeId !== "" ? (
              <Grid2 size={6} style={{}}>
                <Typography style={{ fontWeight: "700" }}>
                  {/* {getJobTypeName(typeId)} */}
                  Tasks
                </Typography>
                <FormGroup>
                  {tasks
                    .filter((t: any) => t.jobTypeId === typeId)
                    .map((t: any) => (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={jobTasks.indexOf(t.id) > -1}
                            onChange={(e) => {
                              addJobTask(t.id, e.target.checked);
                            }}
                          />
                        }
                        label={t.name}
                      />
                    ))}
                </FormGroup>
              </Grid2>
            ) : null}

            <Grid2 size={12} sx={{ border: "1px none green" }}>
              <TextField
                id="outlined-textarea"
                label=""
                value={instructions}
                minRows={3}
                style={{ width: "100%" }}
                onChange={(e) => setInstructions(e.target.value)}
                placeholder="Additional instructions for completing the job"
                multiline
              />
            </Grid2>
            <Grid2 size={12} sx={{ border: "1px none green" }}>
              <Typography style={{ fontWeight: "700" }}>Fee</Typography>
            </Grid2>
            <Grid2 size={12} sx={{ border: "1px none green" }}>
              <Input
                fullWidth
                value={fee}
                onChange={(e) => setFee(e.target.value)}
                type="number"
                id="outlined-start-adornment"
                sx={{}}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  },
                }}
              />
            </Grid2>
            {job.id ? null : (
              <Grid2 size={12} sx={{ border: "1px none green" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isRecurring}
                      onChange={(e) => {
                        setIsRecurring(e.target.checked);
                        if (e.target.checked) {
                          setFrequencyId(constants.frequency.weekly);
                        }
                        
                      }}
                    />
                  }
                  label={"Recurring Job"}
                />
              </Grid2>
            )}
            {isRecurring ? (
              /*TODO change to radio buttons, set frequency*/
              <Grid2 size={12} sx={{ border: "1px none green" }}>
                <FormControl>
                  <FormLabel id="demo-radio-buttons-group-label">
                    Frequency
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="frequency-radio-group"
                    name="frequency-radio-buttons-group"
                    onChange={(e) => setFrequencyId(e.target.value)}
                  >
                    <FormControlLabel
                      value={constants.frequency.weekly}
                      checked={frequencyId === constants.frequency.weekly}
                      control={<Radio />}
                      label="Weekly"
                    />
                    <FormControlLabel
                      value={constants.frequency.biweekly}
                      checked={frequencyId === constants.frequency.biweekly}
                      control={<Radio />}
                      label="Every Other Week"
                    />
                    <FormControlLabel
                      value={constants.frequency.monthly}
                      checked={frequencyId === constants.frequency.monthly}
                      control={<Radio />}
                      label="Monthly"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid2>
            ) : null}
            {isRecurring ? (
              <Grid2 size={12} sx={{ border: "1px none green" }}>
                <FormControlLabel

                  control={
                    <Checkbox
                      checked={isForever}
                      onChange={(e) => {
                        setIsForever(e.target.checked);
                      }}
                      
                    />
                  }
                  label={"Repeat forever"}
                  
                />
              </Grid2>
            ) : null}
            {isRecurring && !isForever ? (
              <Grid2 size={12} sx={{ border: "1px none green" }}>
                <DatePicker
                  sx={{ width: "100%" }}
                  label="Continue Through"
                  value={throughDate}
                  onChange={(newValue) => setThroughDate(newValue || dayjs())}
                />
              </Grid2>
            ) : null}
            {err ? (
              <Grid2 size={12} sx={{ border: "1px none green" }}>
                <Alert severity="error">{err}</Alert>
              </Grid2>
            ) : null}
          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            variant="contained"
            //   type="submit"
            onClick={() => {
              saveJob();
            }}
          >
            {job && job.id ? "Update Job Post" : "Create Job Post"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default JobDialog;
